<template>
	<div class="page-wrapper">
		<transition appear name="fadeslow">
			<div class="menu-layer">
				<navigation :darken="true"></navigation>
			</div>
		</transition>

		<div class="empty-block"></div>

		<transition appear name="fade">
			<div class="portfolio-wrapper">
				<h2>Portfolio</h2>
			</div>
		</transition>

		<div v-if="isMobile" class="categories-container">
			<div class="category-wrapper" @click="portfolioClick(1)">
				<p>FASHION</p>
				<img src="../assets/portfolio/category1.jpg">
			</div>

			<div class="category-wrapper" @click="portfolioClick(2)">
				<p>PORTRAITS</p>
				<img src="../assets/portfolio/category2.jpg">
			</div>

			<div class="category-wrapper" @click="portfolioClick(3)">
				<p>MOOD</p>
				<img src="../assets/portfolio/category3.jpg">
			</div>

			<div class="category-wrapper" @click="portfolioClick(4)">
				<p>WEDDINGS</p>
				<img src="../assets/portfolio/category4.jpg">
			</div>

			<div class="category-wrapper" @click="portfolioClick(5)">
				<p>ARCHITECTURE</p>
				<img src="../assets/portfolio/category5.jpg">
			</div>
		</div>

		<div v-if="!isMobile" class="categories-container">
			<div class="category-wrapper" @click="portfolioClick(1)">
				<p>FASHION</p>
				<img src="../assets/portfolio/category1v.jpg">
			</div>

			<div class="category-wrapper" @click="portfolioClick(2)">
				<p>PORTRAITS</p>
				<img src="../assets/portfolio/category2v.jpg">
			</div>

			<div class="category-wrapper" @click="portfolioClick(3)">
				<p>MOOD</p>
				<img src="../assets/portfolio/category3v.jpg">
			</div>

			<div class="category-wrapper" @click="portfolioClick(4)">
				<p>WEDDINGS</p>
				<img src="../assets/portfolio/category4v.jpg">
			</div>

			<div class="category-wrapper" @click="portfolioClick(5)">
				<p>ARCHITECTURE</p>
				<img src="../assets/portfolio/category5v.jpg">
			</div>
		</div>

		<transition appear name="fadeslow">
			<div class="footer">
				<router-link to="contact">{{ copyright }}</router-link>
			</div>
		</transition>

	</div>
</template>

<script>

	import Navigation from "./Navigation.vue";

	export default {
		name: "PortfolioPage",
		components: {
			Navigation
		},
		data () {
			return {
				copyright: '© TABI | ROBERTO@TABI.SE | STOCKHOLM, SWEDEN'
			}
		},
		computed: {
			isMobile: function() {
				if (screen.width > 600) {
					return false;
				}
				return true;
			}
		},
		methods: {
			portfolioClick: function(param) {
				this.$router.push('/portfolio'+param);
			}
		}
	}

</script>

<style lang="scss" scoped>

	$font-color: #f0f0f0;
	$font-hover-color: #fff;
	$font-image-color: #eee;

	.page-wrapper {
		background-color: #282828;
	}

	.empty-block {
		padding-top: 4rem;
	}

	.portfolio-wrapper {
		padding: 0 2rem;
		padding-top: 0.5rem;
	}

	.menu-layer {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 1;
	}

	h2 {
		font-size: 1.2rem;
		text-align: center;
		color: $font-color;
		margin: 1rem 0 0.5rem 0rem;
		font-weight: 100;
	}

	.categories-container {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		align-items: center;
	}

	.category-wrapper {
		margin: 0;
		padding: 0;
		width: 100%;
		position: relative;
		cursor: pointer;

		p {
			position: absolute;
			left: 0;
			top: 50%;
			width: 100%;
			text-align: center;
			color: $font-image-color;
			text-shadow: 1.5px 1.5px #10101060;
		}
	}

	img {
		width: 100%;
		height: auto;
	}

		/* router-link generates <a> */
	.footer {
		position: fixed;
		text-align: center;
		bottom: 0;
		right: 0;
		width: 100%;
		margin-bottom: 0.20rem;
	}

	a {
		font-size: 0.6rem;
		font-weight: 100;
		color: $font-color;
		text-decoration: none;
	}

	a:hover, li:hover {
		color: $font-hover-color;
		cursor: pointer;
		font-weight: 400;
	}

	@media only screen and (min-width: 600px) {
		.empty-block {
			padding-top: 4rem;
		}

		.categories-container {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
		}

		.category-wrapper {
			margin: 0;
			padding: 0;
			width: 20%;
			position: relative;

			p {
				position: absolute;
				left: 0;
				top: 50%;
				width: 100%;
				text-align: center;
				transition: 0.3s all ease;
				z-index: 1;
			}

			img {
				transition: 0.5s all ease;
			}
		}

		.category-wrapper:hover {
			p {
				font-size: 1.3rem;
			}

			img {
				transform: scale(0.95);
			}
		}

		h1 {
			font-size: 2rem;
		}

		h2 {
			font-size: 1.5rem;
		}

		p {
			font-size: 1rem;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/PortfolioPage.vue